export default "__VITE_ASSET__46d72cdc__"